'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _vehicleLookup = require('../../selectors/vehicle-lookup');
var _vehicleLookup2 = require('../../actions/vehicle-lookup');
var _radio = require('../radio');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var RegLookup = function (_Component) {
  _inherits(RegLookup, _Component);
  function RegLookup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, RegLookup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegLookup.__proto__ || Object.getPrototypeOf(RegLookup)).call.apply(_ref, [this].concat(args))), _this), _this.selectVehicle = function (value) {
      if (value) {
        _this.props.selectVehicle(_this.props.formId, ~~value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegLookup, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_glamorous2.default.Div, {
        paddingBottom: '3rem'
      }, _react2.default.createElement(_radio.RadioClassic, {
        name: 'vehicleOptions',
        label: 'Vehicle',
        placeholder: 'Please select your vehicle',
        options: this.props.options,
        onChange: this.selectVehicle,
        fieldCss: {
          paddingBottom: 0
        },
        error: this.props.error ? 'Please select an option' : undefined
      }), _react2.default.createElement('a', {
        onClick: this.props.resetLookup
      }, 'Try another lookup'));
    }
  }]);
  return RegLookup;
}(_react.Component);
RegLookup.propTypes = {
  // withFormId
  formId: _propTypes.string.isRequired,
  // props
  resetLookup: _propTypes.func.isRequired,
  error: _propTypes.bool.isRequired,
  // stp
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    value: _propTypes.string.isRequired,
    text: _propTypes.string.isRequired
  })).isRequired,
  // dtp
  selectVehicle: _propTypes.func.isRequired
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    options: (0, _vehicleLookup.cdlOptions)(ownProps.formId)(state)
  };
}, {
  selectVehicle: _vehicleLookup2.selectVehicle
})(RegLookup));